import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Breadcrumb } from 'semantic-ui-react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Divider from '@material-ui/core/Divider';
import '../styles/Forms.css';
import claimForm from '../assets/claim_Form.pdf';
import claimProcedure from '../assets/claim_Procedure.pdf';
import creditApplication from '../assets/credit_Application.pdf';
import creditAuthorization from '../assets/credit_Card_Auth.pdf'; 
// import { useHistory } from "react-router-dom";

const breadcrumbSections = [
    { key: 'home', content: 'HOME', href: "/" },
    { key: 'forms', content: 'FORMS', active: true },
]


// function handleClick(event) {
//     event.preventDefault();
// }


// const useStyles = makeStyles((theme) => ({
//     root: {
//       width: '100%',
//       maxWidth: 360,
//       backgroundColor: '#000',
//       alignItems: 'center',
  
//     },
//   }));

function Forms() {
    {/**breadcrumb */}
    // const useStyles = makeStyles((theme) => ({
    //     root: {
    //         '& > * + *': {
    //             marginTop: theme.spacing(2),
    //         },
    //     },
    // }));
   
    return (
        <>
        {/**breadcrumb */}
        <div style={{textAlign: 'left', marginLeft: '70px', marginTop: '80px', textDecoration: 'none'}}>
            <Breadcrumb icon='right angle' sections={breadcrumbSections} style={{backgroundColor: '#fff'}}/>
        </div>

 
        {/**header: Forms */}
        <div className="forms-header">Forms</div>    
        <div className="forms-container" >
        {/**forms */}
            <div className="forms" >
              
            <List sx style={{width: 'auto', height: 'auto'}}>
                <ListItem style = {{marginBottom: '8px'}}>
                    <ListItemAvatar>
                        <div className="pdficon"><PictureAsPdfIcon fontSize="large"/></div>
                    </ListItemAvatar>
                    <div className="pdf-name"><a href ={claimForm} target = "_blank" rel="noopener noreferrer" style={{marginBottom: '10px'}}>Claim</a></div>
                </ListItem>
                <Divider variant="inset" component="li" style={{height: '4px'}}/>
                <ListItem style = {{marginBottom: '8px'}}>
                    <ListItemAvatar>
                        <div className="pdficon"><PictureAsPdfIcon fontSize="large"/></div>
                    </ListItemAvatar>
                    <div className="pdf-name"><a href ={claimProcedure} target = "_blank" rel="noopener noreferrer">Claim Procedure</a></div>
                </ListItem>
                <Divider variant="inset" component="li" style={{color: 'black', height: '4px'}} />
                <ListItem style = {{marginBottom: '8px'}}>
                    <ListItemAvatar>
                        <div className="pdficon"><PictureAsPdfIcon fontSize="large"/></div>
                    </ListItemAvatar>
                    <div className="pdf-name">
                        <a href ={creditApplication} target = "_blank" rel="noopener noreferrer">Credit Application</a>
                    </div>
                </ListItem>
                <Divider variant="inset" component="li" style={{height: '4px', width: '700px'}} />
                <ListItem style = {{marginBottom: '8px'}}>
                <ListItemAvatar>
                        <div className="pdficon"><PictureAsPdfIcon fontSize="large"/></div>
                    </ListItemAvatar>
                    <div className="pdf-name" >
                        <a href ={creditAuthorization} target = "_blank" rel="noopener noreferrer">Credit Card Authorization</a>
                    </div>
                </ListItem>
            </List>       
            </div> 
           
        </div>
        < br />
        < br /> 
        < br />

     
        
        </>
    )
}

export default Forms
